module.exports = __webpack_public_path__ + "img/twitter.2ea11f5f.svg";